import type { ConfigPreviewResponse } from '../types/stockImports.types'

type QuantityHeaders = ConfigPreviewResponse['quantityHeaders']

const normalizeHeader = (header: string | null) =>
  (header ?? '').trim().replace(/\s+/g, ' ').toLowerCase()

export const getQuantityHeaderEntries = (headers: QuantityHeaders) =>
  headers ? Object.entries(headers) : []

export const getFirstQuantityHeader = (headers: QuantityHeaders) =>
  getQuantityHeaderEntries(headers)[0]?.[1] ?? null

export const hasDifferentQuantityHeaders = (headers: QuantityHeaders) =>
  new Set(
    getQuantityHeaderEntries(headers).map(([, header]) =>
      normalizeHeader(header)
    )
  ).size > 1
